import React from "react";

// Function to check the answers and return the result with colors
const checkAnswers = (grid, questions) => {
  const validationResults = [];
  const colors = {}; // Store colors for each cell

  questions.forEach((question) => {
    const { question_number, direction, answer } = question;
    let userAnswer = "";
    let start_row = -1;
    let start_col = -1;

    // Find the starting position for the answer
    for (let row = 0; row < grid.length; row++) {
      for (let col = 0; col < grid[row].length; col++) {
        if (grid[row][col] === answer[0]) {
          let isMatch = true;
          for (let i = 0; i < answer.length; i++) {
            const nextRow = direction === "down" ? row + i : row;
            const nextCol = direction === "across" ? col + i : col;
            if (
              !grid[nextRow] ||
              !grid[nextRow][nextCol] ||
              grid[nextRow][nextCol] !== answer[i]
            ) {
              isMatch = false;
              break;
            }
          }
          if (isMatch) {
            start_row = row;
            start_col = col;
            break;
          }
        }
      }
      if (start_row !== -1 && start_col !== -1) break;
    }

    if (start_row === -1 || start_col === -1) {
      console.log(
        `Skipped Question #${question_number}: Starting position not found.`,
      );

      // Mark all cells related to this question as incorrect (red)
      for (let i = 0; i < answer.length; i++) {
        const row = direction === "across" ? start_row : start_row + i;
        const col = direction === "across" ? start_col + i : start_col;
        colors[`${row}-${col}`] = "#FF6347"; // Mark red for skipped answers
      }

      validationResults.push({
        question_number,
        isCorrect: false,
        correctAnswer: answer,
      });
      return;
    }

    // Extract the user answer
    for (let i = 0; i < answer.length; i++) {
      const row = direction === "across" ? start_row : start_row + i;
      const col = direction === "across" ? start_col + i : start_col;

      if (grid[row] && grid[row][col] !== undefined) {
        userAnswer += grid[row][col];
      } else {
        userAnswer = ""; // Incomplete or invalid
        break;
      }
    }

    if (userAnswer.length === answer.length) {
      const isCorrect = userAnswer.toUpperCase() === answer.toUpperCase();
      const color = isCorrect ? "#90EE90" : "#FF6347";

      // Apply colors for the answer cells
      for (let i = 0; i < answer.length; i++) {
        const row = direction === "across" ? start_row : start_row + i;
        const col = direction === "across" ? start_col + i : start_col;
        colors[`${row}-${col}`] = color;
      }

      validationResults.push({
        question_number,
        isCorrect,
        correctAnswer: answer,
      });
    } else {
      console.log(
        `Skipped Question #${question_number}: User answer length mismatch.`,
      );
    }
  });

  return { validationResults, colors };
};

const CheckButton = ({
  grid,
  questions,
  setCellColors,
  setIsChecked,
  setScore,
}) => {
  const handleCheck = () => {
    const results = checkAnswers(grid, questions);
    setCellColors(results.colors); // Update the cell colors
    setIsChecked(true);

    // Calculate score (number of correct answers)
    const score = results.validationResults.filter((r) => r.isCorrect).length;
    setScore(score);
  };

  return (
    <button
      onClick={handleCheck}
      style={{
        marginTop: "10px",
        height: "38px",
        borderRadius: "4px",
        marginLeft: "5%",
      }}
    >
      Check Answers
    </button>
  );
};

export default CheckButton;
